import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchCommunitydetail } from "../services/Communitydetail";
import { API_BASE } from "../api/apiConfig";

const Communitydetailactivitie = () => {
  const { id } = useParams();
  const [Communitydetaildata, setCommunitydetaildata] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBanner = async () => {
      const res = await fetchCommunitydetail(decodeURIComponent(id));

      if (res?.data) {
         setCommunitydetaildata(res.data);
      }
      setLoading(false);
    };

    loadBanner();
  }, [id]);

  const extractListItems = (html = "") => {
  if (!html) return [];
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");

    return Array.from(doc.querySelectorAll("li"))
      .map(li => li.textContent.trim())
      .filter(Boolean);
  };


  const destinations = JSON.parse(Communitydetaildata?.destination_name || "[]");
  const distances = JSON.parse(Communitydetaildata?.destination_distance || "[]");


  if (loading) return <p className="text-center py-10">Loading...</p>;
  if (!Communitydetaildata) return <p className="text-center py-10">No Data found</p>;

  return (
     <div className="hidden md:grid grid-cols-2 gap-6">
    {/* पहली कार्ड */}
    <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm hover:shadow-md transition-all duration-300 hover:border-primary/30">
      <div className="flex items-center gap-2 mb-3">
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary/10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-compass h-4 w-4 text-primary"
          >
            <path d="m16.24 7.76-1.804 5.411a2 2 0 0 1-1.265 1.265L7.76 16.24l1.804-5.411a2 2 0 0 1 1.265-1.265z" />
            <circle cx="12" cy="12" r="10" />
          </svg>
        </div>
        <h3 className="text-lg font-bold text-slate-800">Popular Activities</h3>
      </div>
      <ul className="space-y-2">
        {/* लिस्ट आइटम्स */}

      {extractListItems(Communitydetaildata?.popular_activitie).map(
        (item, index) => (
          <li key={index} className="flex items-center gap-2">
            <div className="h-1.5 w-1.5 rounded-full bg-primary" />
            <span className="text-sm text-slate-700">{item}</span>
          </li>
        )
      )}

      </ul>
    </div>
    {/* दूसरी कार्ड */}
    <div className="bg-white rounded-xl border border-slate-200 p-5 shadow-sm hover:shadow-md transition-all duration-300 hover:border-primary/30">
      <div className="flex items-center gap-2 mb-3">
        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-primary/10">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-globe h-4 w-4 text-primary"
          >
            <circle cx="12" cy="12" r="10" />
            <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
            <path d="M2 12h20" />
          </svg>
        </div>
        <h3 className="text-lg font-bold text-slate-800">Nearby Destinations</h3>
      </div>
      <ul className="space-y-2">
        {/* स्थानें और दूरी */}

      {destinations.map((place, index) => (
        <li key={index} className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <div className="h-1.5 w-1.5 rounded-full bg-primary" />
            <span className="text-sm text-slate-700">{place}</span>
          </div>
          <div className="inline-flex items-center rounded-full border px-2.5 py-0.5 font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 text-xs border-primary/30 text-primary">
            {distances[index]} km
          </div>
        </li>
      ))}
      </ul>
    </div>
  </div>
  );
};

export default Communitydetailactivitie;
